var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHandler28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7a1.5 1.5 0 1 0 0 3h23a1.5 1.5 0 0 0 0-3h-23ZM1 14a1.5 1.5 0 0 1 1.5-1.5h23a1.5 1.5 0 0 1 0 3h-23A1.5 1.5 0 0 1 1 14ZM1 19.5A1.5 1.5 0 0 1 2.5 18h23a1.5 1.5 0 0 1 0 3h-23A1.5 1.5 0 0 1 1 19.5Z",
    fill: "#F0F0FF",
    fillOpacity: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandler28);
export default __webpack_public_path__ + "static/media/handler_28.a9b1bad0.svg";
export { ForwardRef as ReactComponent };